export default {
  app: {
    place: {
      address: '住所 ',
      showOnExternalMaps: 'グーグル・マップで表示する',
    },
  },
};
